import ProcessEngineType from 'library/src/processing/models/ProcessEngineType';
import { DateTime } from 'luxon';
import { appIntl } from 'shared/utils/IntlGlobalProvider';
import * as yup from 'yup';

export const visioCropValidationSchema = () => {
  return {
    sowing_date: yup
      .string()
      .required(
        appIntl().formatMessage({id: 'fields.validation.visiocrop.sowingDate'}),
      ),
    harvest_date: yup
      .string()
      .test(
        'isLater',
        appIntl().formatMessage({
          id: 'fields.validation.visiocrop.harvestDate.later',
        }),
        function (val) {
          if (val) {
            const startDate = this.parent.sowing_date;
            const sowingDate = DateTime.fromISO(startDate);
            const destructionDate = DateTime.fromISO(val);
            return sowingDate < destructionDate;
          }
          return false;
        },
      )
      .required(
        appIntl().formatMessage({
          id: 'fields.validation.visiocrop.harvestDate',
        }),
      ),
    processing_engine_ref: yup.string().required(
      appIntl().formatMessage({
        id: 'fields.validation.visiocrop.processingEngineRef',
      }),
    ).oneOf(Object.values(ProcessEngineType)),
    crop_id: yup.number().required(
      appIntl().formatMessage({id: 'fields.validation.visiocrop.crop'}),
    ),
    cropping_system_id: yup.string().required(
      appIntl().formatMessage({
        id: 'fields.validation.visiocrop.croppingSystemId',
      }),
    ),
   
  };
};

export const parameterSchema = (processingEngineRef: ProcessEngineType) => {
    switch (processingEngineRef) {
    case ProcessEngineType.VC_RAPESEED_FERTILIZATION:
        return yup.object().shape({
                yield_target: yup.number().required(
                    appIntl().formatMessage({
                     id: 'fields.validation.visiocrop.parameters.yieldTarget',
                  }),
                ),
            })
        
    default:
        return yup.object().shape({});
  }
}
